import { useContext } from "react";
import { useParams } from "react-router-dom";
import FactoryContext from "../../contexts/factoryContext";
import useLeague from "./useLeague";

/**
 *
 * @returns {{leagueQuery: UseQueryResult<*, unknown>, leagueSeason: ?LeagueSeason, league: ?League}}
 */
export default function useLeagueSeason() {
  const factory = useContext(FactoryContext);
  const { league, leagueQuery } = useLeague();
  const { season: seasonStr } = useParams();
  let season = seasonStr ? parseInt(seasonStr, 10) : null;

  let leagueSeason = null;
  if (league) {
    if (league.hasSeason(season)) {
      const leagueSeasonId = league.obj.seasons[season];
      if (leagueQuery.data.leagueSeasons[leagueSeasonId]) {
        const leagueSeasonObj = leagueQuery.data.leagueSeasons[leagueSeasonId];
        leagueSeason = factory.makeLeagueSeason(leagueSeasonObj);
      } else {
        console.error(
          `leagueQuery.data.leagueSeasons does not have leagueSeason ${leagueSeasonId}`
        );
      }
    } else {
      console.error(`league ${league.obj.id} does not have season ${season}`);
    }
  }

  return { leagueSeason, league, leagueQuery };
}
